import { useTranslation } from 'react-i18next';
import UsersPanel from '../components/UsersPanel';

const UsersTab = ({ orgUsers, currentOrg }) => {
  const { t } = useTranslation();

  return (
    <div className="glass metric-card">
      <h5>{t('admin.tab_users')} — {currentOrg}</h5>
      <UsersPanel orgUsers={orgUsers} currentOrg={currentOrg} />
    </div>
  );
};

export default UsersTab;
